module.exports = __webpack_public_path__ + "static/media/ChatIcon.d3612d02.svg";